import { environment } from '../environments/environment';

export const URLS = Object({

	checkSubscription: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}AAASubscriptionStatus`,
		appName: `${environment.boAppName}`
	},
	addSpan: {
		url: `${environment.gatewayBaseUrl}${environment.ttAppBoV2}AddMarginDetailsV1`,
	},
	calculateSpan: {
		url: `${environment.gatewayBaseUrl}${environment.ttAppBoV2}SpanMargincalculationV1`,
	},
	mfAccountReportDownload: {
		url: `${environment.gatewayBaseUrl}${environment.mfApp}GetAccountStatementOfSD`,		// MF
	},
	marginDetails: {
		url: `${environment.gatewayBaseUrl}${environment.ttAppBoV2}GetMarginV1`,
	},
	narnolia:{
		appSourceNarnolia:'4612',
		appSource:'11981'
	},
	delMargin: {
		url: `${environment.gatewayBaseUrl}${environment.ttAppBoV2}DeleteMarginV1`,
	},
	resetMargin: {
		url: `${environment.gatewayBaseUrl}${environment.ttAppBoV2}ResetMarginv1`,
	},
	forgotPass: {
		url: `${environment.gatewayBaseUrl}${environment.ttAppBo}ForgotManagerPassword`,
	},
	swarajLogout: {
		url: `${environment.gatewayBaseUrl}${environment.ttUserActivity}LogOut`,
	},
	backofficeLogout: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBackOffice}EmployeeLogoutV1`,
	},
	swarajCookie: {				// no usage in code. check
		url: `${environment.gatewayBaseUrl}${environment.ttUserActivity}LoginRequestv2`,
	},
	backofficeCookie: {			// no usage in code. check
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}LoginAAAV2`,
	},
	isAgreeCookie: {			// no usage in code. check
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ISAgreed`,
	},
	holdingCookie: {			// no usage in code. check
		url: `${environment.gatewayBaseUrl}${environment.ttUserActivity}MyHolding`,
	},
	marketWatchList: {
		url: `${environment.gatewayBaseUrl}${environment.ttMarket}GetNewMarketWatchV3`,
	},
	getMWatchList: {
		url: `${environment.gatewayBaseUrl}${environment.ttMarket}GetMWatchList`,
	},
	setDefault: {
		url: `${environment.gatewayBaseUrl}tt/TT/Broking/Market/ChangeWLAttributeV1`,
	},
	getMFeedList: {
		url: `${environment.gatewayBaseUrl}tt/Market/MarketFeedAll`,
	},
	deleteScrip: {
		url: `${environment.gatewayBaseUrl}${environment.ttMarket}SaveMWV1`,
	},
	clientList: {
		url: `${environment.gatewayBaseUrl}${environment.ttNewUserActivity}ManagerWiseClientHoldingTrades`,
	},
	userType: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetUserTypeRequestV1`,
		appName: `${environment.boAppName}`
	},
	request1: {					// no usage in code. check
		url: `${environment.gatewayBaseUrl}${environment.ttUserActivity}LoginRequestV2`,
	},
	request2: {					// no usage in code. check
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}LoginAAAV2`,
		appName: `${environment.boAppName}`
	},
	rmProfile: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ProfileDetails`,
		appName: `${environment.boAppName}`
	},
	foliowise: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ClientMFIIFLData`,
		appName: `${environment.boAppName}`
	},
	dashboardReport:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ClientWireDashboardreport`,
	},
	mapRM: {
		url: `${environment.gatewayBaseUrl}${environment.ttClient}ManagerMappingv1`,
	},
	request3: {
		url: `${environment.gatewayBaseUrl}ClientLogin`,						// review. less hits confirm with aaa backend, not configured
	},
	subBroker: {					// no usage in code. check	
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}SubBrokerLoginRequestV4`,
		appName: `${environment.boAppName}`
	},
	subBrokerMap: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetClientSubBrokerMappingRequestV1`,
		appName: `${environment.boAppName}`
	},
	gainers: {
		url: `${environment.gatewayBaseUrl}tt/GainerLooser/GainerLooserV1`,
	},
	changePswd: {			// no usage in code. check
		url: `${environment.gatewayBaseUrl}${environment.ttUserActivity}ChangePassword`,
	},
	grobox: {
		appSource: '6491',
		url:'https://grobox.indiainfoline.com/grobox/api/auth/login/iifl/dealer/'
	},
	isAgree: {				// no usage in code. check
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ISAgreed`,
		appName: `${environment.boAppName}`
	},
	getDates: {
		url: `${environment.gatewayBaseUrl}tt/Scrip/FutureScripDetailsV2`,
	},
	getOptionsDate: {
		url: `${environment.gatewayBaseUrl}tt/Scrip/OptionsScripExpiryV2`,
	},
	getOptionsDetails: {
		url: `${environment.gatewayBaseUrl}tt/Scrip/OptionScripDetailsV2`,
	},
	holding: {			// no usage in code. check
		url: `${environment.gatewayBaseUrl}${environment.ttUserActivity}HoldingAAA`,
	},
	tradeFor: {			// no usage in code. check
		url: `${environment.gatewayBaseUrl}${environment.ttTrading}TradeBookV1`,
	},
	superstar: {
		url: `${environment.gatewayBaseUrl}${environment.aaaSearch}superstarsStock/`,
	},
	superStarIndex: {
		url: `${environment.gatewayBaseUrl}getSuperStarIndex/`,				// not in use, not configured on new gateway
	},
	superStarShares: {
		url: `${environment.gatewayBaseUrl}custom/?superStarName=`,			// not in use, not configured on new gateway
	},
	superStarportfolio: {
		url: `${environment.gatewayBaseUrl}`,
	},
	superStarHistory: {
		url: `${environment.gatewayBaseUrl}`,
	},
	cashfilter: {
		url: `${environment.gatewayBaseUrl}tt/TradingRelatedAPI/CashFilterV1`,
	},
	cashtabdetails: {
		url: `${environment.gatewayBaseUrl}tt/CompanyInfo/CompanyDetailPageV7`,
	},
	marketdepth: {
		url: `${environment.gatewayBaseUrl}tt/Market/MarketDepthServiceAll`,
	},
	futureOptDetails: {
		url: `${environment.gatewayBaseUrl}${environment.papiDerivative}FutOptIndvidualStockDetail-version2/`,
	},
	updateFutureOptDetails: {
		url: `${environment.gatewayBaseUrl}${environment.ttCompanyInfo}CompanyDetailPageV1`,
	},
	cashscripcode: {
		url: `${environment.gatewayBaseUrl}tt/Scrip/GetCashScripCode`,
	},
	getoptionforsymbol: {
		url: `${environment.gatewayBaseUrl}tt/GetDataInfo/GetOptionsForSymbolV1`,
	},
	contractinfo: {
		url: `${environment.gatewayBaseUrl}${environment.ttScrip}ScripDetailsFoFOOrderV3`,
	},
	newstabList: {
		url: `${environment.newsinfoUrl}core/home-page/company-news1/page/1/perpage/15/symbol/`,
	},
	newstabDetails: {
		url: `${environment.newsinfoUrl}core/home-page/article-content/articleid/`,
	},
	weekhighlow: {
		url: `${environment.gatewayBaseUrl}${environment.papiMarket}52weekhighlow-version2/`,
	},
	futGain: {
		url: `${environment.gatewayBaseUrl}${environment.papiDerivative}fogainerlooser-version2`,
	},
	futOIGain: {
		url: `${environment.gatewayBaseUrl}${environment.papiDerivative}FOOGainerLooser-version2`,
	},
	rollOver: {
		url: `${environment.gatewayBaseUrl}${environment.papiDerivative}RollOverPercentage-version2`,
	},
	deliveryPer: {
		url: `${environment.gatewayBaseUrl}${environment.papiMarket}DeliveryPerc-version2`,
	},
	iglScore: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetSubBrokerIGLCScore`,
	},
	flyhighData: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}FlyHigh`,
	},
	premiumPercent: {
		url: `${environment.gatewayBaseUrl}${environment.papiDerivative}PremiumPercent-Version2`,
	},
	mostActiveSTK: {
		url: `${environment.gatewayBaseUrl}${environment.papiDerivative}mostactivestockandindex-version2`,
	},
	scripSymbol: {				// no usage in code. check
		url: `${environment.gatewayBaseUrl}${environment.ttAppBo}GetScripsNDSymbol`,
	},
	getExpiryForsymbol: {		// no usage in code. check
		url: `${environment.gatewayBaseUrl}${environment.ttAppBo}GetExpiryForSymbolOptions`,
	},
	getScripListForSymbol: {	// no usage in code. check
		url: `${environment.gatewayBaseUrl}${environment.ttAppBo}GetCompanyNameForSymbol`,
	},
	commSummaryList: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetCommClientSummary`
	},
	bulkblockdeal: {
		url: `${environment.gatewayBaseUrl}${environment.papiMobileAPI}bulkdeals-version2/`,
	},
	voltopper: {
		url: `${environment.gatewayBaseUrl}tt/StockDetail/TopTradedV1`,
	},
	// searchURL
	equityCash: {
		url: `${environment.gatewayBaseUrl}tt/Scrip/SearchScrip`,
	},
	equityFutureOpt: {
		url: `${environment.gatewayBaseUrl}tt/Scrip/SearchFOScripV3`,
	},
	marketfeedsearch: {
		url: `${environment.gatewayBaseUrl}tt/Market/MarketFeedAll`,
	},
	commodityMarketfeed: {
		url: `${environment.gatewayBaseUrl}tt/Market/MarketFeedAll`,
	},
	currencyFutureOpt: {
		url: `${environment.gatewayBaseUrl}tt/Scrip/FOCurrencyScripListIPADV1`,
	},
	commodityFuture: {
		url: `${environment.gatewayBaseUrl}tt/Scrip/CommodityScripListIPADV1`,
	},
	// Details for future
	searchFutureDetails: {
		url: `${environment.gatewayBaseUrl}tt/Scrip/FutureScripDetailsV2`,
	},
	searchFutCommoDetails: {
		url: `${environment.gatewayBaseUrl}tt/Scrip/CommScripDetailsV1`,
	},
	// Details for future
	searchOptionExpiry: {
		url: `${environment.gatewayBaseUrl}tt/Scrip/OptionsScripExpiryV2`,
	},
	searchOptionScripDetail: {
		url: `${environment.gatewayBaseUrl}tt/Scrip/OptionScripDetailsV2`,
	},
	clientHoldingMargin: {
		url: `${environment.gatewayBaseUrl}${environment.ttAppBoV2}GetClientHoldingAndMarginDetails`,
	},
	amcReport: {
		url: `${environment.gatewayBaseUrl}${environment.mfApp}ConsolidatedAccountStmt`,				// MF
	},
	orderBook: {
		url: `${environment.gatewayBaseUrl}${environment.ttTrading}OrderBookNew`,
	},
	tradeBook: {
		url: `${environment.gatewayBaseUrl}${environment.ttTrading}TradeBookV1`,
	},
	marginV2: {
		url: `${environment.gatewayBaseUrl}${environment.ttTrading}MarginV2`,
	},
	clientLedger1: {
		url: `${environment.gatewayBaseUrl}${environment.ttClient1}/ClientLedgerAAAV2`,
	},
	clientHolding: {
		url: `${environment.gatewayBaseUrl}${environment.ttNewUserActivity}MyHoldingV1`,
	},
	clientNetPositioneq: {
		url: `${environment.gatewayBaseUrl}${environment.ttStockDetail}GetEquityTradeData`,
	},
	clientNetPositioncomm: {
		url: `${environment.gatewayBaseUrl}${environment.ttStockDetail}GetCommodityTradedata`,
	},
	clientHoldingPL: {
		url: `${environment.gatewayBaseUrl}${environment.ttClient1}/HoldingPLSummaryV3`,
	},
		// Client & Trades for Consolidate
	consolidateHolding: {
		url: `${environment.gatewayBaseUrl}${environment.ttUserActivity}HoldingAAA`,
	},
	consolidateCommodityHolding: {
		url: `${environment.gatewayBaseUrl}${environment.ttUserActivity}HoldingCommAAA`,
	},
	consolidateTradeBook: {
		url: `${environment.gatewayBaseUrl}${environment.ttTrading}TradeBookForAAA`,
	},
	consolidateOrderBook: {
		url: `${environment.gatewayBaseUrl}${environment.ttNewOrderbook}OrderBookForV2AAA`,
	},
	fundsPayinOut: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}PayinPayoutDetails_V1`,
		appName: `AAA`
	},
	offlineClients: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}OfflineMFClients`,
		appName: `${environment.boAppName}`
	},
	amcData: {
		url: `${environment.gatewayBaseUrl}${environment.mfApp}GetAMCData`				// MF
	},
	dashboarddetail: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}DashboardDetail_V1`,
		appName: `${environment.boAppName}`
	},
	aumdetail: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}AUMdetails_V1`,
		appName: `${environment.boAppName}`
	},
	overallAum: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}OverallAUMClientwise`,
		appName: `${environment.boAppName}`
	},
	aumEquity: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}EquityAUMClientwise_V1`,
		appName: `${environment.boAppName}`
	},
	aumMutualFund: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}MFAUMClientwise_V1`,
		appName: `${environment.boAppName}`
	},
	aumFDBond: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetFDBondNCDAUMClientwiseDetails`,
		appName: `${environment.boAppName}`
	},
	aumPMS: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetPMSAIFAUMClientwiseDetails`,
		appName: `${environment.boAppName}`
	},
	aumMLDS: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetMLDPTCAUMClientwiseDetails`,
		appName: `${environment.boAppName}`
	},
	sipBook: {			// no usage in code. Check
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}SIPDetails`,
		appName: `${environment.boAppName}`
	},
	sipLive: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}SIPClientwiseDetails`,
		appName: `${environment.boAppName}`
	},
	bouncedCeased: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetAAABouncedCeasedSIP`,
		appName: `${environment.boAppName}`
	},
	insuranceSummary: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetAAAInsuranceSummary`,
		appName: `${environment.boAppName}`
	},
	insuranceDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetAAAInsuranceDetails`,
		appName: `${environment.boAppName}`
	},
	FDSMatureDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetAAABookedMaturedFD_V1`,
		appName: `${environment.boAppName}`
	},
	clientDetail: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}TotalClientsDetails`,
		appName: `${environment.boAppName}`
	},
	clientDetailList: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ViewAllClients`,
		appName: `${environment.boAppName}`
	},
	fetchClientDashboardDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaDashboard}FetchClientDashBoardDetails`,
		appName: `${environment.boAppName}`
	},
	brokerageDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}BrokerageDetails`,
		appName: `${environment.boAppName}`
	},
	brokerageDetailsList: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ClientWiseBrokerage`,
		appName: `${environment.boAppName}`
	},
	brokerageDue: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}BrokerageDue`,
		appName: `${environment.boAppName}`
	},
	hierarchyList: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetRMHierarchyV1`,
	    appName: `${environment.boAppName}`
	},
	// Indices
	indiceMaster: {
		url: `${environment.gatewayBaseUrl}tt/Indice/GetMasterIndiceLocalV1`,
	},
	currCommoIndices: {
		url: `${environment.gatewayBaseUrl}${environment.papiMarket}CurrencyDashboardList`,
	},
	//this url is not  configured on gateway
	// globalMarketIndices: {
	// 	url: `${environment.gatewayBaseUrl}aaa/WebApi/indices#global_indices`,
	// },
	dashHeader: {
		url: `${environment.gatewayBaseUrl}tt/Dashboard/LoginDashboardV1`,
	},
	indiDetails: {
		url: `${environment.gatewayBaseUrl}tt/Indice/IndicesDetailPageV1`,
	},
	//Notification center
	notification: {
		url: `${environment.gatewayBaseUrl}${environment.ttNewNotification}NotificationCentreForAAA`,
	},
		// Market Status
	exchStatus: {
		url: `${environment.gatewayBaseUrl}${environment.ttStockDetail}GetExchengeStatus`,
	},
	pledgeSecurity: {
		url: `https://ttweb.iiflcapital.com/trade/frmPledgeSecurities.aspx`
	},
	OFS: {
		url: `https://ttweb.iiflcapital.com/trade/OfferForSale.aspx`
	},
	BNPL: {
		url: `https://ttweb.iiflcapital.com/trade/paynow.aspx`
	},
	edis: {
		url: `https://ttweb.iiflcapital.com/trade/EdisAuthorization.aspx`
	},
	OTB: {
		url: `https://ttweb.iiflcapital.com/trade/OngoingPublicIssue.aspx`
	},
	CLProfile: {
		url: `https://ttweb.iiflcapital.com/trade/ClientProfileDetailed.aspx`
	},
	// Terms & Condition
	termCondition: {
		url: `${environment.gatewayBaseUrl}${environment.ttDataInfo}TermsAndConditionV1`,
	},
		//Exposure List
	exposureList: {
		url: `${environment.gatewayBaseUrl}tt/Exposure/GetCategoryExposureV1`,
	},
	exposureDescription: {
		url: `${environment.gatewayBaseUrl}tt/Exposure/GetCategoryScriptInfo`,
	},
	payoutFDDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaReport}GetAAAFDPayoutDetails_V1`,
		appName: `${environment.boAppName}`
	},
	payoutBondsDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaReport}GetAAABondPayout_V1`,
		appName: `${environment.boAppName}`
	},
	payoutPmsDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaReport}GetAAAPMSPayout_V1`,
		appName: `${environment.boAppName}`
	},
	payoutMfDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetMFPayout`,
		appName: `${environment.boAppName}`
	},
	ClientWiseMFPayDetail: {
		url: `${environment.gatewayBaseUrl}${environment.aaaReport}ClientWisePayDetail`,
		appName: `${environment.boAppName}`
	},
	payoutMldDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetAAAMLDPayout`,
		appName: `${environment.boAppName}`
	},
	payoutNcdDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaReport}GetAAANCDPayout_V1`,
		appName: `${environment.boAppName}`
	},
	payoutInsuranceDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetAAANewRenewInsurancePayout`,
		appName: `${environment.boAppName}`
	},
	payoutAifDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaReport}GetAAAAIFPayout_V1`,
		appName: `${environment.boAppName}`
	},
	payoutPtcDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetAAAPTCPayout`,
		appName: `${environment.boAppName}`
	},
	totalPayoutDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaReport}TotalPayoutDetails_V1`,
		appName: `${environment.boAppName}`
	},
	eqPayoutDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetAAAEquityPayout`,
		appName: `${environment.boAppName}`
	},
	summaryReport: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetFanSubBrokerPayoutDetailsV1`,
		appName: `${environment.boAppName}`
	},
	dpTransaction: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}DPTransaction`,
		appName: `${environment.boAppName}`,
	},
		// limit request status
	limitReqStatus: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}LimitReqStatus`,
	appName: `${environment.boAppName}`
	},
	// jv request status
	jvReqStatus: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}JVRequestStatus`,
	},
	// client Code for limit and Jv Status
	clientCodesList: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetClientCodes`,
	appName: `${environment.boAppName}`
	},
	//limit insert
	limitInsert: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}LimitReqInsert`,
	appName: `${environment.boAppName}`
	},
	limitValidate: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}LimitReqValidate`,
	appName: `${environment.boAppName}`
	},
	editIpDetail: {
		url: `${environment.gatewayBaseUrl}${environment.aaaTerminal}EditFetchStaticIP`,
		appName:  `${environment.appNameValue}`
	},
	getIpDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaTerminal}FetchStaticIP`,
		appName:  `${environment.appNameValue}`
	},	
	//jv validate
	jvValidate: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}JVValidate`,
	appName: `${environment.boAppName}`
	},
	jvInsert: {
		url: `${environment.gatewayBaseUrl}${environment.aaaJV}InsertJVRequest`,
		AppName: `AAA`,
        AppVer: "01",
        OsName: "Android",
	},
	//borkerge Request
	brokerageApprove: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}JVBrokeragApprovalRights`,
	appName: `${environment.boAppName}`	
	},
	brokergeRequest:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}BrokerageRequestStatus`,
	appName: `${environment.boAppName}`	
	},
	brokergeRequestV1:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}BrokerageRequestStatus_V1`,
		appName: `${environment.boAppName}`	
	},
	//share-deposit
	subBrokerShareDepositDetailsV1:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetFanSubBrokerShareDepositDetailsV1`,
	appName: `${environment.boAppName}`	
	},
	// brokerge Insert
	brokerageReqInsert:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}BrokerageRequestInsert`,
	appName: `${environment.boAppName}`	
	},
	equityDeposit: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetFanSubBrokerEquityDepositDetailsV1`,
		appName: `${environment.boAppName}`,
	},
	brokerageLedger: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetPartnerLedgerDetailsV1`,
		appName: `${environment.boAppName}`,
	},
	//NFDCRiskReport
	nfdcRiskReport:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}NFDCRiskReport`,
	appName: `${environment.boAppName}`	
	},
	scriptExcel:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ScripMasterDetails`,
		appName: `${environment.boAppName}`	
	},
	//RaaDebit
	RaaDebit:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}RAADebitReport`,
	appName: `${environment.boAppName}`	
	},
	//BOD Holding
	BodHolding:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}HoldingDetails`,
		appName: `${environment.boAppName}`	
	},
	//BOD Header
	BodHeader:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}Clientdetailsheader`,
		appName: `${environment.boAppName}`	
	},
	FnoPositions:{		// no usage in code. Check
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}FNOPositions`,
	appName: `${environment.boAppName}`	
	},
	SlbmHoldings:{			// no usage in code. Check
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}SLBMHoldings`,
	appName: `${environment.boAppName}`	
	},
	//client-summary
	clientSummary:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ClientSummary`,
	appName: `${environment.boAppName}`	
	},
	editClientSummary:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}EditClientSummary`,
	appName: `${environment.boAppName}`	
	},
	//client-details-profile-data
	profileDetailsV1:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ProfileDetails_V1`,
		appName: `${environment.boAppName}`	
	},
	//client-pan 
	clientPanNo:{
		url: `${environment.gatewayBaseUrl}${environment.mfApp}GetClientPanNoV1`,
		appName: `${environment.boAppName}`	
	},
	//Brokerage-Info
	brokerageInformation:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetBrokerageInformation`,
	appName: `${environment.boAppName}`	
	},
	//TradeListing
	tradeListing:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}TradeListing`,
	appName: `${environment.boAppName}`	
	},
	settlement: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetSettlementDetails_V1`,
	appName: `${environment.boAppName}`
	},
	//unrealized p&l
	unRealizedPL:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}PnLSummaryUnRealized`,
	appName: `${environment.boAppName}`	
	},
	// realized p&l
	realizedPL:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}PnLSummaryRealizedv1`,
	appName: `${environment.boAppName}`	
	},
	//Fund-transfer Module
	//AvailableAmountForPayout
	availableFund: {
		url: `${environment.gatewayBaseUrl}tt/PayoutPayin/EligiblePayoutAmountForWeb`,
		appName: "IIFLMarkets",	
	},
	// Inter Ledger Transfer
	interLedgerTransfer: {				// no usage in code. Check
		url: `${environment.gatewayBaseUrl}${environment.ttFundTransfer}RequestInterLedgerTransferAAA`,
		appName: "IIFLMarkets",	
	},
	//FundPayoutDetails
	fundPayoutDetail: {
		url: `${environment.gatewayBaseUrl}tt/PayoutPayin/GetFundPayoutDetailsV4`,
	},
	//AvailableAmountForInterTransfer
	amountForInterTransfer: {
		url: `${environment.gatewayBaseUrl}${environment.ttAppBo}AvailableAmountForInterTransfer`,
		appName: "IIFLMFMOB",	
	},
	//dpScript
	dpScript: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetDpScriptPayout`,
	},
	//PayoutRequestAAA
	payOutRequest: {
		url: `${environment.gatewayBaseUrl}tt/PayoutPayin/PayoutRequestV1`,
		appName: `AAA`,
	},
	//PayoutHistory
	payoutHistory: {
		url: `${environment.gatewayBaseUrl}tt/PayoutPayin/PayoutHistoryV1`,
	},
	//Branch List in Client Summary
	BranchMapping: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetRMBranchMapping`,
	appName: `${environment.boAppName}`
	},
	//approved and reject in brokerage Request List
	brokApproRej: {				// no usage in code. Check
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}BrokerageApproveReject`,
	appName: `${environment.boAppName}`
	},
	sipOrderBook: {
		url: `${environment.gatewayBaseUrl}${environment.mfApp}v3/SIPOrderBook`,		//v3/SIPOrderBook
		appName: 'AAA'
	},
	orderBookMf: {
		url: `${environment.gatewayBaseUrl}${environment.mfApp}v3/OrderBook`,			//v3/OrderBook
		appName: 'Mutual Funds by IIFL'
	},
	dpHolding: {
		url: `${environment.gatewayBaseUrl}${environment.mfApp}GetDPHolding`,
		appName: 'AAA'
	},
	statAcc: {
		url: `${environment.gatewayBaseUrl}${environment.mfApp}AccountStatementCall`,
		appName: 'AAA'
	},
	// API to check for product activation flag in wire request
	productActivationRights: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ActiveDeactiveRightsBase`,
		appName: 'AAA'
	},
	// API for brokerage Request Insert V1
	hybridBrokRequest: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}CurrentBrokerage`,
		appName: 'AAA'
	},
	hybridBrokRequestV1: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}CurrentBrokerage_v1`,
		appName: 'AAA'
	},
	// hybrid brok on submit
	brokerageRequestInsertV1: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}BrokerageRequestInsertV1`,
		appName: 'AAA'
	},
	//prod Activation
	actDecProduct: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ActiveDeactiveProduct`,
		appName: 'AAA'
	},
	//portfolio MF
	portfolioMf: {
		url: `${environment.gatewayBaseUrl}${environment.mfApp}V2/PortfolioAPICall`,			// MF
		appName: 'AAA'
	},
	loginAppInfo: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}IAppInfo`,
		appName: 'AAA'
	},
	userOnboard:{
		url: `${environment.gatewayBaseUrl}${environment.aaaSearch}getDIYUserOnBoardData`
	},
	loginValidateUser: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}validateUser`,
		appName: 'AAA'
	},
	loginVerifyUserOTP: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}VerifyUserOTP`,
		appName: 'AAA'
	},
	guestValidateOtp: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GuestLoginValidateOTP_V1`,
		appName: 'AAA'
	},
	guestGenerateOtp: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GuestLogin`,
		appName: 'AAA'
	},
	loginVerifyUserCred: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}VerifyUserCredential`,
		appName: 'AAA'
	},
	loginVerifyUserCredcodifi: {
		url: `${environment.gatewayBaseUrl}AAA/api/AAA/VerifyCodifiLoginCredential`,
		appName: 'AAA'
	},
	loginResetCredential: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ResetCredential`,
		appName: 'AAA'
	},
	loginForgetCred: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ForgetCredential`,
		appName: 'AAA'
	},
	loginForgetCredVarifyOTP: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ForgetCredentialVarifyOTP`,
		appName: 'AAA'
	},
	generateTokenForAAA: {
		url: `${environment.gatewayBaseUrl}${environment.ttUserActivity}GenerateTokenForAAA`,
		appName: 'IIFLMarkets',
	},
	// dashbord revamp
	partnerPoints: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetPartnerPoints`,
		appName: 'AAA'
	},
	ipoList: {
		url: `${environment.gatewayBaseUrl}${environment.ipo}open-issues/ALL`,
	},
	clientCount: {
		onupUrl:'https://oneupcb.indiainfoline.com/issue/detail/code/',
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}FetchClevertapCounts`,
	},
	cmsDeposit: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetCMSDepositBankV1`,
		appName: 'AAA'
	},
	equityCms: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetEquityCMSStatusV1`,
		appName: 'AAA'
	},
	saveCmsEntry: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}SaveCMSEntryV1`,
		appName: 'AAA'	
	},
	oneUploginThrowApp: {
		url: `${environment.gatewayBaseUrl}${environment.ipo}OneUpLoginthrowOtherAppv2`,
	},
	ipoClientList: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}FetchClevertapDetails`,
	},
	getClientHoldingAbove25L: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetClientHoldingAbove25L`,
		appName: 'AAA'
	},
	BusinessOppsFao: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetBusinessOpportunitiesFAO`,
		appName: 'AAA'
	},
	clientWithoutSip: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetMFClientWithOutSIP`,
		appName: 'AAA'
	},
	reportDownload: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBackOffice}reportEmailingv2`,
	},
	exchangeCertificateURL : {
		url: `${environment.gatewayBaseUrl}${environment.aaaDashboard}GetExchangeCertification`,
		AppName: "AAA",
        AppVer: "01",
        OsName: "Android",
	},
	clientNotTraded: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetAAAClientNotTraded`,
		appName: 'AAA'
	},
	clientTobeDormant: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetClientTobeDormant`,
		appName: 'AAA'
	},
	getBrokeragePerformance: {
		url: `${environment.gatewayBaseUrl}${environment.aaaGroBox}GetBrokeragePerformanceDetailsV2`,
		appName: 'AAA'
	},
	getNcdMfDebtHolding: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetAAANCDorMFDebtHolding`,
		appName: 'AAA'
	},
	dayWiseBrokerageGraph: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetDayWiseBrokerageGraph_V1`,
		appName: 'AAA'
	},
	dashBoardCount: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetAAADashBoardCount`,
		appName: 'AAA'
	},
	incentivesPremiaRMs:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}IncentivesPremiaRMs`,
	},
	peerPoints: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetPeerPoints`,
		appName: 'AAA'
	},
	ClientNotInMF: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}CllientsNotInvestedInMF`,
		appName: 'AAA'
	},
	equityMfLeads: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}EquityMFLeads`,
		appName: 'AAA'
	},
	bDayToday: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetListofBdayNext30day`,
	},
	p1p2p3Clients: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetListofP1P2P3Clients`,
	},
	leadStats:{
		url: `${environment.gatewayBaseUrl}${environment.iiflCRM}AAAClientSummaryDetails`,
	},
	fixedIncomeLeads: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}FixedIncomeLeads`,
		appName: 'AAA'
	},
	PmsAifLeads: {
		url: `${environment.gatewayBaseUrl}${environment.aaaDashboard}PMSAIFLeads_V1`,
		appName: 'AAA'
	},
	//Jv Request Status Option
	jvStatusOption: {
		url: `${environment.gatewayBaseUrl}${environment.aaaJV}ApproveRejectJVRequest`,
		AppName: "AAA",
        AppVer: "01",
        OsName: "Android",
	},
	// inflSendOtp: {
	// 	url: `${environment.gatewayBaseUrl}${environment.ipo}SendOTP`,
	// },
	// inflVerifyOtp: {
	// 	url: `${environment.gatewayBaseUrl}${environment.ipo}VerifyOTP`,
	// },
	// getInfluDetail: {
	// 	url: `${environment.gatewayBaseUrl}GetInfluencerDetails`,		// not in use, not configured
	// },
	crmToken: {
		url: `https://dataservice.iiflcapital.com/iiflcrm/Token`
	},
	createLead: {
		url: `${environment.gatewayBaseUrl}${environment.iiflCRM}Save`
	},
	findLead: {
		url: `${environment.gatewayBaseUrl}${environment.iiflCRM}LeadSearchAAA`
	},
	loginSearch:{
		url: `https://dataservice.iiflcapital.com/iiflcrm/V2Login`,
		userKey:environment.userKey
	},
	createTicket: {
		url: `https://dataservice.iiflcapital.com/iiflcrm/CreateTicketinCRMCMMultiAttach`
	},
	searchTicket: {
		url: `https://dataservice.iiflcapital.com/iiflcrm/SearchTicketsinBRCS`
	},
	updateTkt: {
		url: `https://dataservice.iiflcapital.com/iiflcrm/CreateTicketinCRMCustomModuleV2`
	},
	brokingBot: {
		url: `https://dataservice.iiflcapital.com/iiflcrm/BrokingBotRequest`
	},
	holdPhysicalFNOReports: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}SubmitHoldPhysicalFnOReport`,
	},

	getPhysicalFNOReports: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetHoldPhysicalFnOReport`,
	},
	getDPSchemeDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}DPSchemeChargesDetails_V1`,
		},
	getBeyongIRR:{
		url: `https://dataservice.iiflcapital.com/InvestEdge2/accounts/aaa/request`,
	},
	ttMapping: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}TTNowmappingv1`,
	},
	clientProfileCap: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetCaptEngandProfCapt`,
	},
	clientOutstanding: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetClientOutstandingReport`,
	},
	clientRiskProfileScore: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ClientRiskProfileScore`,
	},

	scripSummaryReport: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ScriptSummaryReport`,
	},
	searchZoho: {
		url: `${environment.gatewayBaseUrl}${environment.iiflCRMKbArticles}search`,
	},
	faqSearchZoho: {
		url: `https://dataservice.iiflcapital.com/iiflcrm/AAAarticleList`,
	},
	crmLogin: {
		url: `https://dataservice.iiflcapital.com/iiflcrm/Login`,
	},
	attachToken: {
		url: `https://dataservice.iiflcapital.com/iiflcrm/V2Login`,
	},
	downloadAttachment: {
		url: `${environment.gatewayBaseUrl}iiflcrm/DownloadBrcsTicketFileById`,
	},
	newDownloadAttachment: {
		url: `https://dataservice.iiflcapital.com/iiflcrm/FetchFileMultipartFormat`,
	},
	listZoho: {
		url: `${environment.gatewayBaseUrl}${environment.iiflCRMKbArticles}`,		// not being used, not configured in new gateway
	},
	getLivlong: {
		url: `https://api.livlonginsurance.com/Insurance/authapi/api/v2/Auth/verifyApiKey`,
	},
	deskGetArticle: {
		// url: `${environment.baseUrl}execute`,		old endpoint
		url: `https://dataservice.iiflcapital.com/iiflcrm/desk_get_article`,
	},
	iglcScore: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}IGLCScore`,
	},
	getRootCategoreTree: {
		// url: `${environment.baseUrl}executeV1`,		old endpoint
		url: `https://dataservice.iiflcapital.com/iiflcrm/desk_get_categoretree`,
	},
	getMarginShortfall:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}MarginShortFall`,
	},
	clientInteractionToken:{
		url: `https://dataservice.iiflcapital.com/iiflcrm/Login`
	},
	clientTicketDetails:{
		url: `${environment.gatewayBaseUrl}${environment.iiflCRM}AAAPastClientTicketDetails`
	},
	clientInteractionDetails:{
		url: `${environment.gatewayBaseUrl}${environment.iiflCRM}AAAPastClientInteractionDetails`
	},
	verifyOneLogin:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}VerifyOneLoginUserCredential`
	},
	userInfoOneLogin: {
		url: ''
	},
	commodityrealtimereport:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetCommodityrealtimereport`
	},
	clientPortfolio: {
		url: `${environment.gatewayBaseUrl}${environment.aaa360}ClientPortfolioSummary`,
		appName: 'AAA'
	},
	familyMapp: {
		url: `${environment.gatewayBaseUrl}${environment.aaa360}FamilyMapping`,
		appName: 'AAA'
	},
	clientEqDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaa360}ClientEquityDetails`,
		appName: 'AAA'
	},
	getQuickLink: {
		url: `${environment.gatewayBaseUrl}${environment.aaaDashboard}FetchQuickLinks`
	},
	addQuickLink: {
		url: `${environment.gatewayBaseUrl}${environment.aaaDashboard}AddDeleteQuickLinks`
	},
	crossSellDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaDashboard}GetCrossSellDetails`
	},
	mfDashboard: {
		url: `${environment.gatewayBaseUrl}${environment.aaaDashboard}GetMFDashBoard`
	},
	equityDashboard: {
		url: `${environment.gatewayBaseUrl}${environment.aaaGroBox}GetEquityDashBoard`
	},
	overallDashboard: {
		url: `${environment.gatewayBaseUrl}${environment.aaaGroBox}GetOverAllDashboradCount`
	},
	defaultDashboard: {
		url: `${environment.gatewayBaseUrl}${environment.aaaDashboard}GetDefaultDashboard`
	},
	productWiseClient: {
		url: `${environment.gatewayBaseUrl}${environment.aaaDashboard}GetProductWiseClientCount`
	},
	clientPmsDetails: {			//  no usage in code. check
		url: `${environment.gatewayBaseUrl}${environment.aaa360}ClientPMSDetails`,
		appName: 'AAA'
	},
	clientMfDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaa360}MutualFundDetails`,
		appName: 'AAA'
	},
	clientProductDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaa360}ClientProductSummary`,
		appName: 'AAA'
	},
	clientFdDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaa360}GetClientFDDetails`,
		appName: 'AAA'
	},
	clientBonds: {
		url: `${environment.gatewayBaseUrl}${environment.aaa360}GetClientBondDetails`,
		appName: 'AAA'
	},
	clientAif: {
		url: `${environment.gatewayBaseUrl}${environment.aaa360}ClientAIFDetails`,
		appName: 'AAA'
	},
	clientPms: {
		url: `${environment.gatewayBaseUrl}${environment.aaa360}ClientPMSDetails`,
		appName: 'AAA'
	},
	mappedClient: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetMappedClientList`,
	},
	demapClient: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}DemapClient`,
	},
	familyMember: {
		url: `${environment.gatewayBaseUrl}${environment.aaa360}AddUpdateDeleteResendVerifyFamilyMapping_V1`,
		appName: 'AAA'
	},
	viewBrokerageRights: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}Get_AAA_ViewBrokerageRight`,
	},
	addMenuRights: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}AddUpdateMenuRights`,
	},
	clientMappingTableData:{
		// url: `${environment.gatewayBaseUrl}${environment.aaaBase}v1/GetClientTTMappingClientStatus`,
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetClientTTMappingClientStatus`,
	},
	clientBreakDown: {
		url: `${environment.gatewayBaseUrl}${environment.aaa360}GetClientStockBreakdownDetails`,
		appName: 'AAA'
	},
	tradingListRepo:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ConsolidateTradingReport`,
	},
	commodityScripSum:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}CommodityClientScriptSummary`,
	},
	FetchClientDashBoardDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaDashboard}FetchClientDashBoardDetails`
	},
	freezeDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ListFreezeDetail`,
		appName: 'AAA'
	},
	dpModificationDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}DPModificationReport`,
		appName: 'AAA'
	},
	vasDetailedReport:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}VASDetailReport`,
	},
	GetRMHierarchyNew:{
		url: `${environment.gatewayBaseUrl}${environment.aaaSearch}GetRMHierarchyNew`,
		//url: 'https://aaa-client-search.azurewebsites.net/Client/GetRMHierarchyNew',
	},
	GetClientCodes:{
		url: `${environment.gatewayBaseUrl}${environment.aaaSearch}GetClientCodes`,
		//url: 'https://aaa-client-search.azurewebsites.net/Client/GetClientCodes',
	},
	sessionTransfer: {
		url: `${environment.gatewayBaseUrl}${environment.ttUserActivity}SessionAuthForChatBotLogin`,
	},
	wireMappedCode:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}FetchWireMappedCode`,
	},
	removeClientAccess:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}DeactiveWireParentChild`,
	},
	kpiDashboardBDM: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}KPIDashBoardBDM`,
	},
	disInwardDetail: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}DISInwardDetail`,
		appName: 'AAA'
	},
	searchScripDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}SearchScripDetails`,
		appName: 'AAA'
	},
	epiReqStatus: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}FetchEPIRequest`,
	},
	clientDematHoldings: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}FetchClientDematHoldings`,
	},
	SubmitEPIRequest: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}SubmitEPIRequest`,
	},
	clientMarginReport: {		// no usage in code. check
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ClientMarginReport`,
		appName: 'AAA'
	},
	accountClosureStatus: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}AccountClosureStatus`,
		appName: 'AAA'
	},
	settlementPayoutReport: {
		url: `${environment.gatewayBaseUrl}${environment.aaaReport}GetSettlementPayoutReport_V1`,
		appName: 'AAA'
	},
	dpHoldingStatement: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}DPHoldingStatement`,
		appName: 'AAA'
	},
	dematRequestStatus: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}GetDematRequestStatus`,
	appName: 'Customer360'
	},
	offlineIpo: {		
		url: `${environment.gatewayBaseUrl}${environment.ipo}IPO/RMLoginthrowOtherApp`,
	},
	offlineNcd: {			
		url: `${environment.gatewayBaseUrl}${environment.ipo}IPO/RMLoginthrowOtherApp`,
	},
	MFPNLStatement: {
		url: `${environment.gatewayBaseUrl}${environment.aaa360}MFPNLStatementV1`,
		appName: 'AAA'
	},
	getTotalEquityDividend: {
		url: `${environment.gatewayBaseUrl}${environment.aaa360}GetTotalEquityDividendV1`,
		appName: 'AAA'
	},
	updateRespondedTkt: {
		url: `https://dataservice.iiflcapital.com/iiflcrm/CreateTicketinCRMCustomModuleV2`
	},
	mfRejectionData:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}MFRejectData`,
	},
	FatchCustomMapping:{
		url: `${environment.gatewayBaseUrl}${environment.aaaDashboard}FatchCustomMapping`,
		appName: 'AAA'
	},
	AddDeleteCustomMapping:{
		url: `${environment.gatewayBaseUrl}${environment.aaaDashboard}AddDeleteCustomMapping`,
		appName: 'AAA'
	},
	getFanPayOutDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaDashboard}GetFanPayOutDetails`,
	},
	updateInvoiceNo: {
		url: `${environment.gatewayBaseUrl}${environment.aaaDashboard}UpdateFanPayOutInvoiceNo`,
	},
	nodeUrl: {
		url:`${environment.gatewayBaseUrl}${environment.aaaSearch}users/download-pdf`
	},
	nodeTokenUrl: {
		url:`${environment.gatewayBaseUrl}${environment.aaaSearch}generate-token`,
		appName: `${environment.boAppName}`
	},
	AumExcelReportDownload:{
		url: `${environment.gatewayBaseUrl}${environment.aaaReport}AumReport`,
		appName: 'AAA'
	},
	NodeServerUrl: {
		url:`${environment.gatewayBaseUrl}${environment.aaaSearch}users/download-pdf`
	},
	//Invest Edge
	investEdge:{
		url: `${environment.gatewayBaseUrl}Accounts/accounts/aaa/request`,
	},
	investcurrentTime:{
		url: `${environment.gatewayBaseUrl}InvestEdge2/masters/current-time`,
	},
	//Optimum
	optimum:{
		url: `${environment.gatewayBaseUrl}Invest/api/SSOController/Details`,
		// url: `https://investapi.iiflsecurities.com/api/ssocontroller/details`,
	},
	optimumMenu:{
		url: `${environment.gatewayBaseUrl}Invest/api/AAAMFDataPoint/AccessUserData_AAA`,
	},
	downloadInvoicePdf: {
		url: `${environment.gatewayBaseUrl}${environment.aaaBackOffice}reportEmailingv2`,
		"rptId": "519",
	},
	OnlineSIPExcelReportDownload:{
		url: `${environment.gatewayBaseUrl}${environment.aaaDashboard}GetOnlineSIPReport`,
		appName: 'AAA'
	},
	getNomineeDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaDashboard}GetNomineeDetails`,
	},
	updateNomineeDetails: {
		url: `${environment.gatewayBaseUrl}${environment.aaaDashboard}AddUpdateNomineeDetails`,
	},
	GetJVDetails : {
		url : `${environment.gatewayBaseUrl}${environment.aaaJV}`,
		AppName: "AAA",
        AppVer: "01",
        OsName: "Android",
	},
	clientWiseGroBoxPortfolio: {
		url: `${environment.gatewayBaseUrl}${environment.aaaGroBox}ClientWiseGroBoxPortfolio`,
	},
	redirectExternalGroboxBasket: {
		appSource: '274',
		url: 'https://grobox.indiainfoline.com/grobox/api/auth/login/iifl/dealer/?next=/basket/'
	},
	redirectExternalGroboxInvestment: {
		appSource: '274',
		url:'https://grobox.indiainfoline.com/grobox/api/auth/login/iifl/dealer/?next=/account/investment/'
	},
    getGroTableData: {
        url: `${environment.gatewayBaseUrl}${environment.aaaGroBox}GetClientwiseGroboxAUM`,
    },
	getBasketList: {
        url: `${environment.gatewayBaseUrl}${environment.aaaGroBox}GetBasketName`,
    },
	getConsent: {
		url:`${environment.gatewayBaseUrl}InvestEdge2/investments/external/consent/`
	},
	generateLinkInvestedge: {
		url:`${environment.gatewayBaseUrl}InvestEdge2/investments/external/link`
	},
	generateLinkInvestedgeRm:{
		url:`${environment.gatewayBaseUrl}InvestEdge2/instant-review/link/`
	},
	generateLinkInvestedgeStock:{
		url:`${environment.gatewayBaseUrl}InvestEdge2/investments/external/stocks/refresh`

	},
	getHoldingAndSummary:{
		url:`${environment.gatewayBaseUrl}InvestEdge2/investments/external/`

	},
	ttRefreshToken:{
			url: `${environment.gatewayBaseUrl}${environment.ttUserActivity}RefreshformauthAAA`,
			},
	trackAssetExternal:{
		url:`${environment.gatewayBaseUrl}InvestEdge2/investments/external/tracker/`

	},
	userActivationToken :{ 
		url : `${environment.gatewayBaseUrl}eaccount/GetTokenv1`,
		appSource : 'ONLINEWEB'
	},

	modificationStatus : {
		url : `${environment.gatewayBaseUrl}eaccount/api/Common/GetModificationStatus`,
		appSource : 'OnlineWeb'
	},
	uploadOmnenestClient:{
        url: `${environment.gatewayBaseUrl}aaa/API/Dashboard/ProcessClientInOmnenest`,
    },
	clientTerminalMapingTT:{
		url:`${environment.gatewayBaseUrl}aaa/api/Dashboard/FetchClientTerminalMapping`,
	}
	,
	dashboardReport1:{
		url: `${environment.gatewayBaseUrl}${environment.aaaBase}ClientWireDashboardreportV1`,
	},
		taxPnlReport:{
			url: `${environment.gatewayBaseUrl}${environment.aaaBase}generatebloburl`,
			},

	newTTTradeApi:{
		url: `${environment.gatewayBaseUrl}tt/TradingRelatedAPI/GetOntRealTimeData`,
		appName: "IIFLMarkets",
	},
	appSetting:{
		url: `${environment.gatewayBaseUrl}${environment.aaaSearch}settingsenv`,
	},
	clientoremphierarchy:{
		url: `${environment.gatewayBaseUrl}aaa/auth`,
	},
	arnNodeUrl: {
		url:`${environment.gatewayBaseUrl}${environment.aaaSearch}users/web-scrapper`,
		appName: `${environment.boAppName}`
	},
	GuestCaptureDetails : {
		url : `${environment.gatewayBaseUrl}${environment.aaaDashboard}`,
		appName: `${environment.appNameValue}`,
        appVer: "01",
        osName: "Android",
	},
	generateTokenExtentedApi:{
		url:`${environment.gatewayBaseUrl}extentedapi/LoginRequestMobileForVendor`,
		appVer: "01",
        osName: "Android",
	},
	verifyPan : {
		url : `${environment.gatewayBaseUrl}BackOfficeWebApi/`,
		appName: `${environment.boAppName}`,
        appVer: "01",
        osName: "Android",
	},
	VerifyGuestMobileOrEmail:{
		url:`${environment.gatewayBaseUrl}extentedapi/VerifyGuestMobileOrEmail`,
		appVer: "01",
        osName: "Android",
	},
	guestDetails : {
		url : `${environment.gatewayBaseUrl}${environment.aaaDashboard}`,
		appName: `${environment.appNameValue}`,
        appVer: "01",
        osName: "Android",
	},
	captureGuestPayment : {
		url : `${environment.gatewayBaseUrl}${environment.aaaDashboard}SaveGuestPaymentdetails`,
		appName: `${environment.boAppName}`,
        appVer: "01",
        osName: "Android"
	},
	xirrScriptViceValue:{
		url: `${environment.gatewayBaseUrl}${environment.aaa360}GetScripWiseXirr`,
	},
	xirrValue:{
		url: `${environment.gatewayBaseUrl}${environment.aaa360}GetXirr`,
	},
	offlineDetailsCapture:{
		url: `${environment.gatewayBaseUrl}${environment.aaaReport}GetCrossSellClientList`,
	},
	SaveClientOfflineDetails:{
		url: `${environment.gatewayBaseUrl}${environment.aaaReport}SaveCrossSellClient`,
	},
	revenueCalculator:{
		url: `${environment.gatewayBaseUrl}${environment.aaaRevenueSimulation}RevenueCalculator`,
	},
	revenueAssumptions:{
		url: `${environment.gatewayBaseUrl}${environment.aaaRevenueSimulation}GetRevenueAssumptions`,
		
	},
	saveRevenueSimulation:{
		url: `${environment.gatewayBaseUrl}${environment.aaaRevenueSimulation}Save_RevenueSimulationTracker`,
		
	},
	fetchRevenueTracker:{
		url: `${environment.gatewayBaseUrl}${environment.aaaRevenueSimulation}FetchRevenueTracker`,
		
	},
	RevenueTrackerDetail:{
		url: `${environment.gatewayBaseUrl}${environment.aaaRevenueSimulation}RevenueTrackerDetail`,
		
	},
	zentechContractNotes: {
		url: `${environment.gatewayBaseUrl}BackOfficeWebAPI/api/BackOffice/GetZentechContractnotes`,
	},
	fileUploadService:{
		url: `${environment.gatewayBaseUrl}FileUploadService/api/Upload/UploadFile`,
		key: `${environment.paramsAPIKey}`,
		appName: `${environment.boAppName}`
	},
	getBankName:{
		url: `${environment.gatewayBaseUrl}aaa/api/Report/GetBankName`,
		key: `${environment.paramsAPIKey}`,
		appName: `${environment.boAppName}`
	},
	PendingPledgeRequests:{
		url: `${environment.gatewayBaseUrl}${environment.aaaReport}GetPendingPledgeRequests`,
	},
	SubmitPledgeTransactionForRiskApproval:{
			url: `${environment.gatewayBaseUrl}${environment.aaaReport}SubmitPledgeTransactionForRiskApproval`,
	},
	captureRetentionMailerRequest: {
		url: `${environment.gatewayBaseUrl}aaa/api/RetentionMailer/CaptureRetentionMailerRequest`,
	},
	retentionMailerRequestStatus: {
		url: `${environment.gatewayBaseUrl}aaa/api/RetentionMailer/GetRetentionMailerRequestStatus`,
	},
	PartnerInfoReport:{
			url: `${environment.gatewayBaseUrl}${environment.aaaReport}PartnerInfoReport`,
	},
	getOffMarketTransactionRate:{
			url: `${environment.gatewayBaseUrl}${environment.Offmarket}GetOffMarketTransactionRate`,
	},
	getOffMarketTransactionRateHistroy:{
		url: `${environment.gatewayBaseUrl}${environment.Offmarket}GetOffMarketTransactionRateHistroy`,
	},
	SplitUpdatePriceOffMarketTransactions:{
		url: `${environment.gatewayBaseUrl}${environment.Offmarket}SplitUpdatePriceOffMarketTransactions`,
	},
	UpdatePriceOffMarketTransactions:{
		url: `${environment.gatewayBaseUrl}${environment.Offmarket}UpdatePriceOffMarketTransactions`,
	},
	vendorAuthorize:{
		url: `https://api.iiflcapital.com/v1/sso/vendor/authorize`,
	}
})

// export const SECRET_KEY: string = '$2a$10$e.oPc.dyrwRoQCpDvO9Rhe';
